import axios from '../axiosConfig';
import '../css/modalCancelarInscripcion.css'
import { handleError, toastError, toastSuccess } from '../funciones';

function DeseaCancelar(props){

    function cerrarModal(){
        document.getElementById(props.id + '-btnCloseCancelar').click();
        if(props.id==='desaprobarUsuario' && parseInt(localStorage.getItem(process.env.REACT_APP_DESDE_PERFIL)) === 1){
            localStorage.removeItem(process.env.REACT_APP_DESDE_PERFIL);
            document.getElementById('abrirPerfil').click();
           
        }
    }

    function eliminarInscripcion(){
        const idInscripcion = localStorage.getItem(process.env.REACT_APP_ID_INSCRIPCION);
        const params = { 
            params:{ 
                id: idInscripcion
            }
        }
        axios
        .delete(process.env.REACT_APP_URL + 'inscripcion', params)
        .then((res) => {
            props.agregarModificado(idInscripcion);
            toastSuccess("Inscripción Cancelada")
            cerrarModal()
        })
        .catch(function (error) {
            toastError(handleError(error))
        })
        
    }

    function funcionAdmin(){
        props.funcionAdmin()
        
        cerrarModal()
    }
    function cancelarReunion(parametros){
        var idReunion = parametros.idReunion;
        var idEmpresa = parametros.idEmpresa;
        const idInscripcion = localStorage.getItem(process.env.REACT_APP_ID_INSCRIPCION);
        const params = { 
            params:{ 
                idInscripcion: idInscripcion,
                idEmpresa: idEmpresa
            }
        }
        axios
        .post(process.env.REACT_APP_URL + 'inscripcion/eliminarEmpresaInteres', null, params)
        .then((res) => {
            props.cambiarActividad(localStorage.getItem(process.env.REACT_APP_ID_INSCRIPCION), -1, idReunion, 2);
            toastSuccess("Reunión Cancelada")
            cerrarModal()
        })
        .catch(function (error) {
            toastError(handleError(error))
        })
        
    }

    return(  
        <>  
                        
            <div class="modal fade" id={props.id} data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered ">
                    <div class="modal-content rounded-4 ">
                    
                        <div class="modal-body p-0">
                            <button type="button" id={props.id + '-btnCloseCancelar'} class="btn-close btn-close-modal d-none" 
                            data-bs-dismiss="modal" data-bs-target={"#" + props.id} aria-label="Close"></button>
                            <div className='container py-4'>
                                <div className='row'>
                                
                                <p className='fw-bold mb-0 text-center pb-4'>
                                    {props.id==='cancelarInscripcion'?
                                        <>¿Está seguro que desea cancelar su inscripción?</>
                                    :props.id==='desaprobarUsuario'?
                                        <>¿Está seguro que desea desaprobar esta empresa?</>
                                    :props.id==='eliminarEvento'?
                                        <>¿Está seguro que desea eliminar este evento?</>
                                    :
                                        <>¿Está seguro que desea cancelar la reunión?</>
                                    }
                                </p>
                                    
                                
                                <div className='text-center'>
                                    <button class="btn btn-outline-primary bold-botones mx-3 btnCancelInscModal btn-cuadrado" type="submit"  
                                    onClick={props.id==='cancelarInscripcion'?
                                            eliminarInscripcion
                                        :props.id==='desaprobarUsuario' || props.id==='eliminarEvento'?
                                            funcionAdmin
                                        :
                                            ()=>cancelarReunion(props.params)
                                    } >Sí</button>
                                
                                    <button class="btn colorPrincipal text-white bold-botones mx-3 btnCancelInscModal btn-cuadrado" type="submit" onClick={cerrarModal}>No</button>
                                </div>
                            </div></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    );
}


export default DeseaCancelar;